export class SupplierOrderPalletModel {
    id: number;
    lineIfsId: string;
    qty: string;
    printQty: string;
}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/models/supplier-order-pallet.model.ts